import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import qs from "qs";
// import { Fade } from "react-awesome-reveal";

import "../../utilities.css"
import "./Home.css";

import TopBanner from "../modules/TopBanner.js";
import ButtonFlex from "../modules/ButtonFlex.js";
import ContentBlock from "../modules/ContentBlock.js";
import AllNews from "../modules/AllNews.js";
import AllEvents from "../modules/AllEvents.js";
import Image from "../modules/Image.js";
import { scrollToTop } from "../../utilities.js";
import QuickLinks from "../modules/QuickLinks.js";

import TopBannerImage from "../../img/topbanner/temp_eurovision.png";
import MitchellBuilding from "../../img/topbanner/mitchell_building.jpg";
import WomenRowing from "../../img/topbanner/univ_women_boat_club.jpg";
import CoffeePouring from "../../img/topbanner/banner_coffee.jpg";

const Home = () => {
  const [news, setNews] = useState([]);
  const [events, setEvents] = useState([]);
  const [statusToColor, setStatusToColor] = useState({});
  const [quickLinks, setQuickLinks] = useState([]);

  const getNews = async () => {
    const query = qs.stringify({
      sort: ['updatedAt:desc'],
      pagination: {limit: 3},
      populate: {
        banner: {
          fields: ['alternativeText', 'url'],
        },
      },
    });

    const response = await axios.get(`/strapi/api/news?${query}`);
    setNews(response.data.data);
  };

  const getEvents = async () => {
    const currentClockTime = new Date();
    const currentClockTimeMinusHour = new Date(currentClockTime);
    currentClockTimeMinusHour.setHours(currentClockTimeMinusHour.getHours() - 1);

    const query = qs.stringify({
      sort: ['startDate'],
      pagination: {limit: 6},
      filters: {
        $or: [
          {
            endDate: {$gt: currentClockTime.toISOString()}
          },
          {
            $and: [
              {endDate: {$null: true}},
              {startDate: {$gt: currentClockTimeMinusHour.toISOString()}}
            ]
          }
        ],
      },
      populate: {
        banner: {
          fields: ['alternativeText', 'url'],
        },
        eventCategory: {
          fields: ['name', 'lightBkgColor']
        },
        natures: {
          fields: ['name', 'bkgColor', 'textColor'],
        },
      },
    });

    const response = await axios.get(`/strapi/api/events?${query}`);
    setEvents(response.data.data);
  };

  const getStatusColor = async () => {
    const query = qs.stringify({
      sort: "name:asc",
      fields: ['name', 'bkgColor']
    })
    
    await axios.get(`/strapi/api/event-statuses?${query}`
      ).then((response) => {
        const catsObj = response.data.data
        const colorObj = catsObj.reduce((acc, { name, bkgColor }, index) => {
        acc[name] = { bkgColor: bkgColor };
        return acc;
      }, {})
      setStatusToColor(colorObj);
    })
  };

  const getQuickLink = async () => {
    await axios.get(`/strapi/api/quick-links`
      ).then((response) => {setQuickLinks(response.data.data);
    })
  }

  useEffect(() => {
    getNews(); 
    getStatusColor().then(getEvents());
    getQuickLink();
  }, []);

  const todayDate = new Date();

  return (
    <>
      <TopBanner 
        backgroundImage={TopBannerImage} 
        bgColorKey="black" 
        title="Home" 
        content="Welcome to the University College WCR" />
      { // only render freshers' page button from August to October
        ((todayDate.getMonth() > 6) & (todayDate.getMonth() < 10)) ?  
          <ContentBlock title="Freshers' Updates">
            <div>
              We are glad that you are joining us this year! Click below to view the latest information for your arrival. 
              Please also check out our <Link to="/freshers" onClick={scrollToTop}>dedicated freshers' page</Link>.
            </div>
            <ButtonFlex display={[
              {key: 1, isLocal: true, des: "WCR Freshers' Page", link: "/freshers"},
              {key: 2, isLocal: false, des: "College New Student Page", link: "https://www.univ.ox.ac.uk/learn-at-univ/new-students"}
            ]}/>
          </ContentBlock> : <></>
      }

      <ContentBlock title="What would you like to do today?">
      <div className="u-gridPic-3">
          <Image title="Learn more about us" 
                src={MitchellBuilding}
                opacity={.5}
                isBlack={Boolean(true)}
                aspect="16/9"
                suppressArrow={Boolean(true)}
                des="We were founded in the 1960s to represent the graduate members of the University College, Oxford."
                linkdes="/about"
                isLocal={Boolean(true)}
                altText="The Mitchell Building where we are based."/>
          <Image title="Try something new" 
                src={WomenRowing}
                opacity={.5}
                isBlack={Boolean(true)}
                aspect="16/9"
                suppressArrow={Boolean(true)}
                des="At University College, there are a diverse range of college societies to meet our members' interests."
                linkdes="/societies"
                isLocal={Boolean(true)}
                altText="Members of boat club ready to set off."
                />
          <Image title="Get welfare advice" 
                src={CoffeePouring}
                opacity={.5}
                isBlack={Boolean(true)}
                aspect="16/9"
                suppressArrow={Boolean(true)}
                des="Feeling exhausted of work? We are here for you!"
                linkdes="/welfare"
                isLocal={Boolean(true)}
                altText="Coffee being poured."
                />
          </div>
      </ContentBlock>

      <ContentBlock title="News">
        <p>For more events, please visit our <Link to="/news" onClick={scrollToTop}>news page</Link>.</p>
        <AllNews newsArr={news} />
      </ContentBlock>

      <ContentBlock title="Upcoming Events">
        <div>For more events, please visit our <Link to="/events" onClick={scrollToTop}>list of events</Link> page 
          or check out our <Link to="/termcard" onClick={scrollToTop}>WCR term card</Link>.
        </div>
        <AllEvents 
          eventsArr={events}
          natureFltr={{}}
          catFltr={{}}
          statusToColor={statusToColor}
        />
      </ContentBlock>

      <ContentBlock title="Quick Links">
        <QuickLinks quickLinks={quickLinks}/>
      </ContentBlock>
    </>
  );
}

export default Home;
